const GH_PORTS = [
  { label: "Accra International Airport - Accra (ACC)", value: "Accra International Airport - Accra (ACC)" },
  { label: "Kumasi Airport - Kumasi (KMS)", value: "Kumasi Airport - Kumasi (KMS)" },
  { label: "Tamale Airport - Tamale (TML)", value: "Tamale Airport - Tamale (TML)" },
  { label: "Takoradi Airport - Sekondi-Takoradi (TKD)", value: "Takoradi Airport - Sekondi-Takoradi (TKD)" },
  { label: "Sunyani Airport - Sunyani (NYI)", value: "Sunyani Airport - Sunyani (NYI)" },
  { label: "Wa Airport - Wa (WZA)", value: "Wa Airport - Wa (WZA)" },
  { label: "Ho Airport - Ho (HOA)", value: "Ho Airport - Ho (HOA)" }
]

export const GH_FIELDS = {}

export const GH_APPLICATION_FIELDS = {
  purpose_of_visit: {
		type: 'buttons',
		props: {
			options: [
				{
					label: 'Tourism / Leisure',
					value: 'tourism'
				},
				{
					label: 'Visiting Friends or Relatives',
					value: 'visiting'
				}
			]
		}
	},
  entry_type: {
    type: 'buttons',
    props: {
      label: 'Entry Type',
      options: [
        { label: 'Single Entry', value: 'single' },
        { label: 'Multiple Entry', value: 'multiple' }
      ]
    }
  },
  processing_speed: {
    type: 'select',
    props: {
      label: 'Processing Speed',
      options: [
        { label: 'Standard', value: 'standard' },
        { label: 'Express', value: 'express' },
        { label: 'Priority', value: 'priority' }
      ]
    }
  },
  arriving_from: {
    type: 'input',
    props: {
      label: 'Place of Departure',
      maxLength: 100
    }
  },
  port_of_entry: {
    type: 'select',
    props: {
      label: 'Port of Entry',
      options: GH_PORTS
    }
  },
  destination_city: {
    type: 'input',
    props: {
      label: 'Destination City',
      maxLength: 100
    }
  },
  type_of_accommodation: {
    type: 'buttons',
    props: {
      label: 'Type of Accommodation',
      options: [
        { label: 'Hotel', value: 'hotel' },
        { label: 'Residential', value: 'residential' },
        { label: 'Other', value: 'other' }
      ]
    }
  },
  hotel_name: {
    type: 'input',
    props: {
      label: 'Hotel Name',
      maxLength: 100
    }
  },
  address: {
    type: 'input',
    props: {
      label: 'Address in Ghana',
      maxLength: 200
    }
  },
  length_of_stay: {
    type: 'input',
    props: {
      min: 1,
      step: 1,
      type: 'number',
      label: 'Length of Stay (days)'
    }
  },
  next_destination: {
    type: 'input',
    props: {
      label: 'Next Destination',
      maxLength: 100
    }
  },
  yellow_fever_vaccine: {
    answer: {
      type: 'yes-no-buttons'
    },
    certificate: {
      props: {
        type: 'pdf_document',
        message: 'Ghana requires proof of yellow fever vaccination. Please upload your vaccination certificate.',
        friendly_name: 'Yellow Fever Vaccination Certificate'
      }
    }
  },
  public_health_alert: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  criminal_offence: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  overstay: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  sanctions: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  tour_operator: {
    answer: {
      type: 'yes-no-buttons'
    },
    name: {
      type: 'input',
      props: {
        label: 'Tour Operator Name',
        maxLength: 100
      }
    }
  }
}
